import React from 'react'
import { useLocation, Link } from 'react-router-dom'
import about from '../images/about_org.jpg'
import about_logo from '../images/about copy.jpg'
import team from '../images/team.jpg'
import Logo from '../components/Logo'
import { useDocTitle } from '../components/CustomHook'
import CommonContainer from "../components/CommonContainer";
import { commonStyles } from "../pages/commonStyles";
function About() {
  const location = useLocation()

  // Split the current location pathname into segments
  const pathSegments = location.pathname.split('/').filter(Boolean)
  useDocTitle("About");

  return (
    <div>
     <div className="relative overflow-hidden mt-4 lg:mt-0 h-[320px] md:h-[380px] lg:h-[450px]">
        <div className="absolute inset-0 z-0">
          <img
            src={about}
            alt="Background"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="absolute inset-0 bg-black bg-opacity-50 z-10"></div>


       <div className="relative z-20 h-full flex items-center justify-center text-center text-white">
        <h2 className={`${commonStyles.pageTitle} text-white`}>
  About Us
</h2>
        </div>
      </div>
     <CommonContainer>
  <div className="flex flex-col lg:flex-row items-center my-8 gap-8 lg:gap-12">

  <div className="w-full mb-4 lg:mb-0  my-5">
    <img
      src={about_logo}
      alt="Company Image"
      className="w-full h-auto object-cover rounded-lg shadow-lg"
    />
  </div>

 <div>

  <h1 className={`${commonStyles.heading} mb-6`}>
      Welcome to the <span className="italic">QuadProSoft Technologies</span>
    </h1>
    <p className={`${commonStyles.paragraph} mb-4`}>
      We are an IT company dedicated to providing quality software development and consulting services that offer a strategic combination of technology expertise and business insight.
    </p>
   <p className={`${commonStyles.paragraph} mb-4`}>
      We realize that in today's expanding and varied global marketplace, no single solution meets all business needs. The key, therefore, is to understand the precise requirement of each business context and to leverage technology to address the specific requirements of each customer. This translates into a dedicated process-based approach for each of our tasks.
    </p>

</div>

          </div>
          </CommonContainer>
         <CommonContainer>
  <div className="pt-5">
 <p className={`${commonStyles.paragraph} mb-4`}>
              We are planning to grow customers worldwide, QuadProSoft is expanding globally and is looking to take on larger and more challenging projects. Whether it is outsourced software development or project management or a pure IT-expertise-based consulting requirement, you will find that QuadProsoft Technologeis has the skill set and experience required to meet your specific needs.
            </p>
            </div>
            </CommonContainer>
            <div>
          <CommonContainer>
  <div className="flex flex-col lg:flex-row items-center lg:items-start my-10 gap-8 lg:gap-12">

  <div className="w-full lg:w-2/3 lg:pr-8 text-center lg:text-left">
    <h1 className={`${commonStyles.heading} mb-6`}>Our Team</h1>
    <p className={`${commonStyles.paragraph} mb-4`}>
      One of the strongest reasons for our growth has been the continuous leadership and strength of our senior team. What started off with just a vision has today led to a large but consolidated group of professionals working closely with senior management to translate the vision into concrete functionality leading, in turn, to sustained ROI for a client group that today spans the entire globe. Our core team includes the following people:
    </p>
  </div>


  <div class="w-full lg:w-1/3 mb-6 lg:mb-0">
    <img
      src={team}
      alt="Team Image"
      class="rounded-lg shadow-lg w-full object-cover"
    />
  </div>
</div>
</CommonContainer>



<CommonContainer>
  <div className="py-8">
<div class="grid grid-cols-1 md:grid-cols-3 gap-16 px-4 place-items-center">
<Logo  logo={"PA"} title={"Priscilla Allen"} position={"CEO"} description={"Priscilla is one of the founding members of QuadProSoft. With over 28 years of experience in software and project management, Priscilla has seen the market evolve over the years and has leveraged her experience to ensure that QuadProSoft stays on the growth course she helped conceptualize and formulate. With a bachelors in Marketing and Management and Masters in Community and Family Care Counseling, Because of this Priscilla doesn't just understand business development; she also has the technical skills required to lead right off from the front."} />

<Logo  logo={"MC"} title={"Mohanram"} position={"VP operations"} description={"Coming into QuadProSoft during its earliest days, Mohanram has been our key management guy right from the start. With over 40 years in the Management and automobile industry, Mohanram has a deep understanding of what it takes to make a company like QuadProSoft tick. Resilient and resourceful, Mohanram has helped QuadProSoft grow from strength to strength, with effective management strategies. As VP Operations, Mohanram is responsible for continuous development and overall efficiency within the organization."} />

<Logo  logo={"SR"} title={"Mr Suresh Rajappa"} position={"Director"} description={
  "PSM-certified IT Leader and Architect with 21 years of experience directing large-scale, enterprise technology projects from conception to delivery. Combines robust project management skills spanning risk, cost, and scope management with deep technical expertise in SaaS, Cloud, DevOps, and automated testing. A forward-thinking strategist adept at aligning modern delivery frameworks with emerging AI/ML"}/>
<Logo  logo={"JR"} title={"Jayaraman Ramamoorthy"} position={"CTO"} description={"Jayaraman Ramamoorthy brings in over two decades of rich experience in the IT industry spanning across product development, delivery and cloud computing. He is the backbone of the application development and product delivery and a key player in the design and architecture of the property management software. Jayaram was with IBM before, where he was technology support and development for BBC and Tata Steel, Jayaram holds a Masters in Computer Science from the University of Madras."} />

<Logo  logo={"SM"} title={"Saranya Mohan"} position={"VP HR"} description={"Highly accomplished HR leader with 10 years of experience driving strategic growth, talent development, and organizational excellence. Equipped with an MBA from the prestigious Anna University, Saranya brings a unique blend of business acumen and HR expertise to deliver impactful results."} />

<Logo  logo={"TV"} title={"Thiyagarajan Vasudevan"} position={"VP Sales"} description={"Thiyagarajan understands business. Period. One of the chief reasons for our growth has been this one fact. Supported by the slim team of researchers and sales professionals that he has built over the years, Thiyagarajan is singlehandedly responsible for the continued stream of work that has come our way. And yet, it's not quite just that. Thiyagu also understands which way the team needs to go if we are to remain competitive. Combining strategy with sales, Thiyagu has been instrumental in securing contracts that have leveraged the best of our abilities while enabling us to grow in areas that would further add to our core competencies."} />




<Logo  logo={"LB"} title={"Lokesh Boopathy"} position={"Manager Finance"} description={"Lokesh oversees accounting, finance, and IT. Lokesh has extensive knowledge of accounting and finance, having led our finance department and played a key role in the company's finances since its inception. Before joining Quadprosoft, Lokesh had experience in finance roles at major electronics manufacturers and has extensive experience in corporate financial management and systems."} />


</div>
</div>
</CommonContainer>

            </div>

    </div>
  )
}

export default About
